import Script from "next/script";
import { FC, useCallback, useContext, useEffect } from "react";
import { AuthContext, useRuntimeConfig } from "@finbackoffice/site-core";

export interface ISmarticoProps {
    core_inbox_unread_count?: number;
}

type Props = {
    locale?: string;
    onLoad?: () => void;
    userId?: number;
};

export const SmarticoScript: FC<Props> = ({ onLoad, locale, userId }) => {
    const { isUserLoggedIn } = useContext(AuthContext);

    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");

    useEffect(() => {
        setSmarticoVars();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    const setSmarticoVars = useCallback(() => {
        // window._smartico_allow_localhost = true;
        if (isUserLoggedIn) {
            window._smartico_language = locale ?? "";
            window._smartico_user_id = userId ? userId.toString() : "";
        } else {
            window._smartico_language = null;
            window._smartico_user_id = null;
        }
    }, [isUserLoggedIn, userId, locale]);

    const onSmarticoScriptLoad = useCallback(() => {
        setSmarticoVars();
        window._smartico.init(COMMON_SITE_CONFIGS.crm.config.labelId, {
            brand_key: COMMON_SITE_CONFIGS.crm.config.brandId,
        });
        onLoad?.();
    }, [
        COMMON_SITE_CONFIGS.crm.config.brandId,
        COMMON_SITE_CONFIGS.crm.config.labelId,
        onLoad,
        setSmarticoVars,
    ]);

    return (
        <Script src="https://libs.smartico.ai/smartico.js" onLoad={onSmarticoScriptLoad} async />
    );
};
